<div class="responsive-card gap-4">
  <div i18n class="responsive-card-title">Deposit Instructions</div>
  <div *ngIf="!hasChanges && !displayCard.isWrittenCheque && !displayCard.paylineAccount" i18n class="subtitle">
    Payments will be deposited to the bank account listed.
  </div>

  <ng-container *ngIf="!hasChanges; else comparisonView">
    <ng-container *ngTemplateOutlet="cardContent; context: { card: displayCard }" />
  </ng-container>

  <ng-template #comparisonView>
    <div class="d-flex flex-column gap-3">
      <span class="label-sm" i18n>Current</span>
      <ng-container *ngTemplateOutlet="cardContent; context: { card: currentCard, isCurrentState: true }" />
    </div>
    <div class="d-flex flex-column gap-3">
      <span class="label-sm" i18n>New</span>
      <ng-container *ngTemplateOutlet="cardContent; context: { card: newCard, isNewState: true }" />
    </div>
  </ng-template>
</div>

<ng-template #cardContent let-card="card" let-isCurrentState="isCurrentState" let-isNewState="isNewState">
  <div class="inner-card d-flex flex-column gap-3" [class.current]="isCurrentState" [class.new]="isNewState">
    <ng-container *ngIf="card.isWrittenCheque; else accountDetails">
      <div i18n class="account-name">Written Cheque</div>
    </ng-container>

    <ng-template #accountDetails>
      <ng-container *ngIf="card.paylineAccount; else bankAccountDetails">
        <div class="account-name" i18n>Payline {{ card.paylineAccount.accountNumber }}</div>
        <div class="bank-info-grid">
          <app-review-entry label="Currency Type" i18n-label [value]="card.paylineAccount.currency.name" />
          <app-review-entry label="Account Number" i18n-label [value]="card.paylineAccount.accountNumber" />
          <app-review-entry label="Payline Bank" i18n-label [value]="card.paylineAccount.bankName" />
        </div>
        <div i18n class="date-added">Date Added: {{ card.paylineAccount.createdDate | date : 'MMM d, y' }}</div>
      </ng-container>
    </ng-template>

    <ng-template #bankAccountDetails>
      <div class="account-name">{{ card.bankAccount?.nickname }}</div>
      <div class="bank-info-grid">
        <app-review-entry label="Institution Number" i18n-label [value]="card.bankAccount?.institutionNumber" />
        <app-review-entry label="Transit Number" i18n-label [value]="card.bankAccount?.transitNumber" />
        <app-review-entry label="Account Number" i18n-label [value]="card.bankAccount?.accountNumber" />
      </div>
      <div i18n class="date-added">Date Added: {{ card.bankAccount?.createdDate | date : 'MMM d, y' }}</div>
    </ng-template>
  </div>
</ng-template>
